import { request as http } from '@/utils/http'
import type {
  PageResponse,
  PriceAirPageRequest,
  PriceAirListVO,
  PriceAirVO,
  PriceAirSaveRequest,
  BatchDeleteRequest,
  BatchModifyHeaderRequest,
  BatchModifyResult,
  PriceChargingItemDTO
} from './types'

// 分页查询空运运价
export const page = (params: PriceAirPageRequest) => {
  return http.post<PageResponse<PriceAirListVO>>('/price/air/page', params)
}

// 匹配空运附加费
export const matchSurcharges = (id: string) => {
  return http.post<PriceChargingItemDTO[]>('/price/air/match-surcharges', { id })
}

// 获取空运运价详情
export const getDetail = (id: string) => {
  return http.post<PriceAirVO>('/price/air/get', { id })
}

// 新增空运运价
export const save = (params: PriceAirSaveRequest) => {
  return http.post<number>('/price/air/save', params)
}

// 更新空运运价
export const update = (params: PriceAirSaveRequest) => {
  return http.post<boolean>('/price/air/update', params)
}

// 批量删除空运运价
export const batchDelete = (params: BatchDeleteRequest) => {
  return http.post<boolean>('/price/air/batch-delete', params)
}

// 批量更新有效期
export const batchUpdateTime = (params: any) => {
  return http.post<boolean>('/price/air/batch-update-time', params)
}

// 批量发布空运运价
export const batchPublish = (params: BatchDeleteRequest) => {
  return http.post<boolean>('/price/air/batch-publish', params)
}

export const precheckBatchPublish = (params: BatchDeleteRequest) => {
  return http.post<boolean>('/price/air/batch-publish-precheck', params)
}

export const precheckBatchOffline = (params: BatchDeleteRequest) => {
  return http.post<boolean>('/price/air/batch-offline-precheck', params)
}

export const precheckBatchDelete = (params: BatchDeleteRequest) => {
  return http.post<boolean>('/price/air/batch-delete-precheck', params)
}

// 批量下架空运运价
export const batchOffline = (params: BatchDeleteRequest) => {
  return http.post<boolean>('/price/air/batch-offline', params)
}

// 批量修改表头字段
export const batchModify = (params: BatchModifyHeaderRequest) => {
  return http.post<BatchModifyResult>('/price/air/batch-modify', params)
}

/** 从供应商报价导入空运运价 */
export interface ImportFromQuotationRequest {
  quotationId?: string
  quotationIds?: string[]
  surchargeSyncType?: number
  source?: number
}

export const importFromQuotation = (params: ImportFromQuotationRequest) => {
  return http.post<any>('/price/air/import-from-quotation', params)
}

export interface ConfirmImportFromQuotationRequest {
  batchNo: number | string
  priceIds?: string[]
  source?: number
  quotationIds?: string[]
}

export const confirmImportFromQuotation = (params: ConfirmImportFromQuotationRequest) => {
  return http.post<any>('/price/air/confirm-import-from-quotation', params)
}
